'use client';

import { NestedHome } from '@habity/types';
import { DynamicCTAs } from './DynamicCTAs';

interface HomeProfileCTAsProps {
  home: NestedHome;
}

/**
 * HomeProfileCTAs component that renders dynamic action buttons based on home state
 * This component now uses the DynamicCTAs component which handles different states:
 * - Active bidding: "Följ budgivning" button
 * - Bookable viewings: "Boka visning" button
 * - Default: Standard interest button
 */
export function HomeProfileCTAs({ home }: HomeProfileCTAsProps) {
  return <DynamicCTAs home={home} />;
}
